<template>
    <div class="modal select-none fixed inset-0 z-50 overflow-x-hidden overflow-y-auto">
        <div
            class="relative mx-auto z-20"
            :class="{
                'px-4 py-8': !fullWidth,
                'bg-white min-h-full': fullWidth
            }"
        >
            <div><slot /></div>
        </div>
    </div>
</template>

<script>
import composedPath from '@mobile/polyfills/composedPath';
import { eventBus } from '@/eventBus';

export default {

    props: {
        classWhitelist: [Array, String],
        fullWidth: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({ modalBg: null }),

    created() {
        document.addEventListener('keydown', this.handleEscape);
        eventBus.$emit('modalOpen');

        const modalBg = document.createElement('div');
        modalBg.classList.add('fixed', 'inset-0', 'bg-80', 'z-20', 'opacity-75');

        this.modalBg = modalBg;

        document.body.appendChild(this.modalBg);
    },

    destroyed() {
        document.removeEventListener('keydown', this.handleEscape);
        eventBus.$emit('modalClose');
        document.body.removeChild(this.modalBg);
    },

    methods: {
        handleEscape(e) {
            e.stopPropagation();

            if (e.keyCode == 27) {
                this.close();
            }
        },

        close(e) {
            const classArray = Array.isArray(this.classWhitelist)
                ? this.classWhitelist
                : [this.classWhitelist];

            if (_.filter(classArray, (className) => pathIncludesClass(e, className)).length > 0) {
                return;
            }

            this.$emit('modal-close', e);
        },
    },
};

function pathIncludesClass(event, className) {
    return composedPath(event)
        .filter((el) => el !== document && el !== window)
        .reduce((acc, e) => acc.concat([...e.classList]), [])
        .includes(className);
}
</script>
